import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import moment from 'moment';
import { NgxMaterialTimepickerTheme } from 'ngx-material-timepicker';

@Component({
    selector: 'dbm-time-picker',
    template: require('./dbm-time-picker.component.html'),
    styles: [require('./dbm-time-picker.component.scss')]
})
export class DbmTimePickerComponent implements OnInit{

    @Input() public timeObject: any;
    @Input() public timeObjectName: string;
    @Output() public onSave: EventEmitter<any> = new EventEmitter<any>();
    public format: string;

    public customTheme: NgxMaterialTimepickerTheme = {
        container: {
            bodyBackgroundColor: '#fff',
            buttonColor: '#000'
        },
        dial: {
            dialBackgroundColor: 'rgb(144,164,174)',
            dialActiveColor : 'rgba(0, 0, 0, 1)',
            dialInactiveColor: 'rgba(0, 0, 0, 0.4)'
        },
        clockFace: {
            clockHandColor: 'rgb(96,125,139)',
            clockFaceTimeActiveColor : '#fff'
        }
    };

    constructor() {
        this.format = 'HH:mm';
    }

    public ngOnInit(): void {
        this.setValidTimeIfNot();
    }

    public setValidTimeIfNot() {
        if (!this.timeObject || !moment(this.timeObject, 'HH:mm').isValid()) {
            this.timeObject = moment().format('HH:mm');
        }
    }

    public changeTimeObject(time): void {
        this.setValidTimeIfNot();
        const currentTime = moment(time, this.format).format(this.format);
        this.timeObject = currentTime;
        this.onSave.emit({ timeValue: currentTime, timeType: this.timeObjectName, format: this.format });
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/basic-components/dbm-time-picker/dbm-time-picker.component.ts